export default __webpack_public_path__ + "a6507cfc594138b6651015f252fbd688.svg";